<div class="errwrap">
  <div class="errdiv1" id="errs">

  </div>
</div>

<div *ngIf="actionmode=='Add' || actionmode=='Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">

      <h1 class="screen-title">{{screentitle}}</h1>

      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode=='Add' || actionmode=='Edit'" class="btn back-button button-margin ">

          <!-- //****************** -->

          <button class="approved" [disabled]="RAC_APROVE!=1"
            *ngIf="isApproved   && actionmode =='Edit' && rejected!=2  ">

            <span class="bold">Approved</span>
          </button>
          <input type="button" [disabled]="RAC_APROVE!=1" class="btn btn-success commonbutt"
            style="width: 80px;font-weight: 700" value="Active" id="btnname" (click)="changeName()"
            *ngIf="isApproved  && actionmode =='Edit'  && rejected!=2">
          <!-- //****************** -->

          <button
            [disabled]="nameExist|| showList==true || rpmValueNotNumeric || notValidRpmValue || cancellatonPValueNotNumeric || notValidPercentage || endDateInvalid"
            class="btn btn-success commonbutt" type="button" (click)="submitdata()">
            <em class="fa fa-check"></em>&nbsp;Submit </button>

          <button
            [disabled]="nameExist|| showList==true || rpmValueNotNumeric || notValidRpmValue || cancellatonPValueNotNumeric || notValidPercentage || endDateInvalid"
            class="btn btn-success commonbutt" type="button"
            *ngIf="    !isApproved && updateApprove && RAC_APROVE =='1'" data-toggle="modal" data-target="#myModal">
            <em class="fa fa-thumbs-up "></em>&nbsp;&nbsp;
            <span class="bold">Approve</span>
          </button>
          <button
            [disabled]="nameExist|| showList==true || rpmValueNotNumeric || notValidRpmValue || cancellatonPValueNotNumeric || notValidPercentage || endDateInvalid"
            class="btn btn-warning commonbutt" type="button"
            *ngIf="   !isApproved &&      updateApprove && RAC_APROVE =='1'" data-toggle="modal"
            data-target="#myModal2">
            <em class="fa fa-thumbs-down"></em>
            <span class="bold">Reject</span>
          </button>

          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close</button>

        </div>
      </div>

    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>

                    <div class="col-lg-3">
                      <label>Select Tier</label>
                      <select class="form-control" [(ngModel)]="screen_details.TIER_TYPE"
                        [disabled]="actionmode =='Edit'" (change)="gotochangestatus()">

                        <option value="">Select Tier</option>
                        <option *ngFor="let tier of tiers" value="{{ tier.key }}">{{ tier.value }}</option>
                      </select>
                    </div>
                    <div class="col-lg-3">
                      <label>Set Rpm</label>
                      <input [(ngModel)]="screen_details.RPM" type="text" [disabled]="showList==true"
                        class="form-control m-input" placeholder="Enter Rpm" id="RPM" #RPM="ngModel" name="RPM" value=""
                        (blur)="changenew($event.target.value)" (input)="checkRPMValue($event.target.value)"
                        (change)="gotochangestatus()" />
                      <span *ngIf="rpmValueNotNumeric" style="color: red">Accepts numeric values only.</span>
                      <span *ngIf="notValidRpmValue" style="color: red">Please enter valid number.</span>
                    </div>
                    <div class="col-lg-3">
                      <label>JP Cancellation Penalty</label>
                      <input disabled [(ngModel)]="screen_details.CANCELLATION_PENALTY" type="text"
                        [disabled]="showList==true" class="form-control m-input"
                        placeholder="Enter Cancellation Penalty" id="CANCELLATION_PENALTY"
                        #CANCELLATION_PENALTY="ngModel" name="CANCELLATION_PENALTY" value=""
                        (input)="checkCancellationPValue($event.target.value)" maxlength="3"
                        (change)="gotochangestatus()" />
                      <span *ngIf="cancellatonPValueNotNumeric" style="color: red">Accepts numeric values only.</span>
                      <span *ngIf="notValidPercentage" style="color: red">percentage must be between 0 to 100.</span>
                    </div>
                    <div class="clr"></div>
                    <div class="divider">
                    </div>

                    <div class="col-lg-3">
                      <mat-form-field>
                        <input matInput [(ngModel)]="screen_details.APPLICABLE_FROM" [min]="newDate"
                          [matDatepicker]="pickerFrom" (dateChange)="checkStartDate($event)" (focus)="pickerFrom.open()"
                          (click)="pickerFrom.open()" autocomplete="off" placeholder="Valid From" readonly>
                        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                        <mat-datepicker #pickerFrom></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                      <mat-form-field>
                        <input matInput [(ngModel)]="screen_details.APPLICABLE_TO"
                          [min]="screen_details.APPLICABLE_FROM" [matDatepicker]="pickerTo"
                          (dateChange)="checkEndDate($event)" (focus)="pickerTo.open()" (click)="pickerTo.open()"
                          autocomplete="off" placeholder="Valid Till" readonly>
                        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                        <mat-datepicker #pickerTo></mat-datepicker>
                      </mat-form-field>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- ########## rate per mile modal-->
<div class="modal fade" id="myModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;">
        <button type="button" (click)="clearRemark()" class="close" data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-thumbs-up" style="margin-right: 10px"></span>Do you want to
          approve ?
        </h4>
      </div>

      <div class="modal-body">
        <div class="col-lg-13">
          <label> Remarks</label>
          <textarea (blur)="checkRemarkLength($event.target.value)"
         (input)="getremark($event.target.value);"   
         [(ngModel)]="aprove_details.APPROVAL_REMARKS" 
             rows="8" cols="20" type="text" class="form-control m-input"
            placeholder="Enter  Remarks">
          </textarea>
          <span *ngIf="minRemark" 
           class="m-form__help" 
          style="color: red">Please enter Remarks with minimum length
            3</span>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="!aprvbtn" (click)="aproveReject(1)"
        class="btn btn-success " type="button" 
          data-dismiss="modal">
          <span class="bold">Yes</span>
        </button>

        <button (click)="clearRemark()" 
        class="btn btn-warning " type="button" 
        data-dismiss="modal">
          <span class="bold">No</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ########## rate per mile modal-->

<!-- ########## modal 2-->
<div class="modal fade" id="myModal2" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;">
        <button type="button" class="close" (click)="clearRemark()" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-thumbs-down" style="margin-right: 10px"></span>Do you want to reject ?</h4>
      </div>
      <div class="modal-body">
        <div class="col-lg-13">
          <label>Remarks</label>
          <textarea 
            [(ngModel)]="aprove_details.APPROVAL_REMARKS" 
            rows="8" (input)="getremark($event.target.value);"
            (blur)="checkRemarkLength($event.target.value)" 
            cols="20" type="text" 
            class="form-control m-input"
            placeholder="Enter  Remarks">
          </textarea>
          <span 
          *ngIf="minRemark" class="m-form__help" 
          style="color: red">Please enter Remarks with minimum length 3</span>
        </div>
      </div>
      <div class="modal-footer">
        <button 
        [disabled]="!aprvbtn" class="btn btn-success" 
        type="button" (click)="aproveReject(2)"
          data-dismiss="modal">
          <span class="bold">Yes</span>
        </button>
        <button class="btn btn-warning " 
        (click)="clearRemark()" type="button" 
        data-dismiss="modal">
          <span class="bold">No</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ########## modal 2 ends-->


<div 
*ngIf="actionmode!='Add' && 
actionmode!='Edit' && actionmode!='View'"
 class="searchdiv">
  <div class="headerdiv">
    <h1>
      Rate Per Mile Search
    </h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" *ngIf="RAC_ADD =='1'" type="button" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New</button>

    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div style="padding: 2% 2% 2% 2%">
                <div>
                  <div class="wr15">



                    <div class="instruct">
                      <div class="int1" style="margin-left: 17px">
                        <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                        <br />


                        <span class="txt">
                          1. Select at least one value out of Tier,RPM

                        </span>
                        <br />
                        <span class="txt">
                          2. You can also use a combination of the given fields to search </span>
                        <br />
                        <span></span>
                      </div>
                    </div>

                    <div class="col-lg-3">
                      <label>Select Tier</label>
                      <select class="form-control" [(ngModel)]="search_details.TIER_TYPE">
                        <option value="">Select Tier</option>
                        <option *ngFor="let searchTier of searchTiers" value={{searchTier.key}}>
                          {{searchTier.value}}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-3">
                      <label class="">Enter RPM</label>
                      <input [(ngModel)]="search_details.RPM" type="text" class="form-control m-input"
                        placeholder="Enter Rpm">
                    </div>
                  </div>
                </div>
                <div class="btn clear-button button-margin">
                  <button class="btn btn-primary commonbutt" style="margin-top: 20px" (click)="searchData()"
                    type="button">
                    <em class="fa fa-search "></em>&nbsp;Search</button>
                </div>
              </div>


              <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlist">
                <div style="padding: 2% 2% 2% 2%" [hidden]="searchlist">
                  <table aria-describedby="rpmDetails" class="table table-striped" [mfData]="serachtabledata"
                    [mfRowsOnPage]="5">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 14%" *ngIf="RAC_VIEW =='1' && RAC_EDIT =='1'">
                          Actions
                        </th>
                        <th scope="col" style="width: 14%">
                          <mfDefaultSorter by="TIER_TYPE">Tier</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 14%">
                          <mfDefaultSorter by="RPM">Rpm</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 17%">
                          <mfDefaultSorter by="RPM">JP Cancellation Penalty
                          </mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 15%">
                          <mfDefaultSorter by="RPM">Start Date</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 15%">
                          <mfDefaultSorter by="RPM">End Date</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 50%">
                          <mfDefaultSorter by="RPM">Status</mfDefaultSorter>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of serachtabledata | paginate: { itemsPerPage: 10, currentPage: p }">
                        <td *ngIf="RAC_VIEW =='1' && RAC_EDIT =='1'">
                          <button class="btn btn-default btn-circle" *ngIf="RAC_VIEW =='1'" type="button"
                            (click)="showFormData(item.RATE_PER_MILE_ID,1,1,1)">
                            <em class="fa fa-eye"></em>
                          </button>
                          <span *ngIf="item.STATUS!='2' && item.PRE_APPROVE!='1'">
                            <button class="btn btn-default btn-circle" *ngIf="RAC_EDIT =='1'" type="button"
                              (click)="showFormData(item.RATE_PER_MILE_ID,2,item.STATUS,item.APPROVAL_STATUS)">
                              <em class="fa fa-pencil"></em>
                            </button>
                          </span>
                        </td>
                        <td>{{ item.TIER_TYPE }}</td>
                        <td>{{ item.RPM }}</td>
                        <td>{{ item.CANCELLATION_PENALTY }}</td>
                        <td>{{ item.APPLICABLE_FROM }}</td>
                        <td>{{ item.APPLICABLE_TO }}</td>
                        <td>


                          <div *ngIf="item.APPROVAL_STATUS == 0 &&
                                item.STATUS == 0 &&
                                item.PRE_APPROVE != 1">
                            <span class="icls1">
                              <button class="btn commonbutt zol1">Inactive</button>
                              <span class="tooltiptext">Not Approved</span>
                            </span>
                          </div>

                          <div *ngIf="item.APPROVAL_STATUS == 1 && 
                                item.PRE_APPROVE != 1">
                            <span class="icls1">
                              <button class="btn  commonbutt zol" 
                              *ngIf="item.STATUS == 1">
                                Active
                              </button>

                              <button class="btn  commonbutt zol1" 
                              *ngIf="item.STATUS == 0">
                                Inactive
                              </button>

                              <span class="tooltiptext"> Approved </span>

                            </span>
                          </div>
                          <div *ngIf="item.APPROVAL_STATUS == 0 && 
                                item.PRE_APPROVE == 1">
                            <span class="icls1">
                              <button class="btn  commonbutt zol">Active</button>
                              <span class="tooltiptext"> Approved </span>
                            </span>
                          </div>


                          <div 
                          *ngIf="item.APPROVAL_STATUS == 2 && 
                          item.STATUS == 2">
                            <span class="icls5">
                              <button class="btn  commonbutt zol1">Inactive</button>
                              <span class="tooltiptext">Rejected</span>
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="7">

                          <pagination-controls (pageChange)="p = $event"></pagination-controls>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div 
                *ngIf="loader">
                  <div style="margin: 0 auto; text-align: center;">
                    <img
                      src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                      width="8%" height="8%" alt="Loader">
                  </div>
                </div>
                <!-- loader ends  -->
              </div>
            </div>
          </div>
        </div>
        <!-- forms end  -->
      </div>
    </div>
  </div>
</div>



<div 
*ngIf="actionmode =='View'" 
class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title" 
      *ngIf="showList==!false">{{viewTitle}}</h1>
      <h1 class="screen-title" 
      *ngIf="showList==false">{{insertDataTitle}}</h1>
      <div class="button-wrapper bothbuttdiv2">
        <div 
        *ngIf="actionmode=='View'" 
        class="btn back-button button-margin ">
          <button class="btn btn-danger commonbutt" 
          (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close</button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <!-- action mode form starts  -->
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>
                      <div class="tdive">
                        <table aria-describedby="rpmTier" class="viewtable">
                          <div *ngFor="let q of serachTableInfo">

                            <tr>
                              <th scope="col">
                                <span class="vlbl">Tier Type</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.TIER_TYPE }}</span>
                              </td>
                            </tr>

                            <tr>
                              <th scope="col">
                                <span class="vlbl">RPM</span>
                              </th>
                              <td>

                                <span class="vVal">{{ q.RPM }}</span>

                              </td>
                            </tr>

                            <tr>
                              <th scope="col">
                                <span class="vlbl">JP Cancellation Penalty</span>
                              </th>
                              <td>

                                <span class="vVal">{{ q.CANCELLATION_PENALTY }}</span>

                              </td>
                            </tr>

                            <tr>
                              <th scope="col">
                                <span class="vlbl">Applicable Form</span>
                              </th>
                              <td>
                                <span class="vVal"> {{ q.APPLICABLE_FROM }} </span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">

                                <span class="vlbl">Applicsble To</span>
                              </th>
                              <td>
                                <span class="vVal"> {{ q.APPLICABLE_TO }} </span>
                              </td>
                            </tr>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>